import React from "react"
import { ArticleContentComponentContainer } from "../utils"

export const List = ({ content }) => {
  return (
    <ArticleContentComponentContainer>
      <div
        className=" bfz-article-list"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </ArticleContentComponentContainer>
  )
}
